
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 20 20"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M7.81 2.005h-.316l-.135.285L6.4 4.312H3.436a.5.5 0 000 1h.61l.405 11.246a1.5 1.5 0 001.499 1.446h8.096a1.5 1.5 0 001.5-1.446l.403-11.246h.612a.5.5 0 000-1h-2.965l-.959-2.022-.135-.285H7.81zm-.303 2.307l.62-1.307h3.742l.62 1.307H7.507zm7.441 1h-9.9l.402 11.21a.5.5 0 00.5.482h8.096a.5.5 0 00.5-.482l.402-11.21zM8.311 8.274a.5.5 0 00-1 0v6.346a.5.5 0 001 0V8.274zm1.687-.5a.5.5 0 01.5.5v6.346a.5.5 0 01-1 0V8.274a.5.5 0 01.5-.5zm2.188 0a.5.5 0 01.5.5v6.346a.5.5 0 01-1 0V8.274a.5.5 0 01.5-.5z","fill":"#303133"}})])
          )
        }
      }
    